document.querySelectorAll( '.etch-video-referenz__video-wrap' ).forEach( ( wrap ) => {
	const btn   = wrap.querySelector( '.etch-video-referenz__play-overlay' );
	const video = wrap.querySelector( '.etch-video-referenz__video' );

	if ( ! btn || ! video ) return;

	btn.addEventListener( 'click', () => {
		btn.style.display = 'none';
		video.removeAttribute( 'hidden' );
		video.play();
	} );
} );
